import { ApiCollection }   from 'modelx-jts-common';
import ActivityDomainModel from 'models/fondationsModels/ActivityDomainModel';
import EntityCategoryModel from 'models/fondationsModels/EntityCategoryModel';
import EntityStatusModel   from 'models/fondationsModels/EntityStatusModel';
import EntityTypeModel     from 'models/fondationsModels/EntityTypeModel';
import { observable }      from 'mobx';
import { action }          from 'mobx';

export class EntityReferenceStore {
	public isLoaded = false;

	@observable public activityDomainCollection = new ApiCollection(ActivityDomainModel);
	@observable public entityCategoryCollection = new ApiCollection(EntityCategoryModel);
	@observable public entityStatusCollection   = new ApiCollection(EntityStatusModel);
	@observable public entityTypeCollection     = new ApiCollection(EntityTypeModel);

	@action
	public async load() {
		if (this.isLoaded) {
			return;
		}

		this.isLoaded = true;

		try {
			await Promise.all([
				this.activityDomainCollection.list(),
				this.entityCategoryCollection.list(),
				this.entityStatusCollection.list(),
				this.entityTypeCollection.list(),
			]);
		} catch {
			this.isLoaded = false;
		}
	}
}

export const entityReferenceStore = new EntityReferenceStore();